/**
 *
 * @param pageName 페이지명
 * @param containerType 컨테이너 유형
 * @param tagRole 태그 역할
 * @param tagType 태그 유형
 * @param details 상세 정보
 * @returns <페이지명>-<containerType>-<tagRole>-<tagType>-<detailOption(optional)>
 */
export function generateTagId(
  pageName: PageNameOption,
  containerType: ContainerTypeOption,
  tagType: TagTypeOption,
  tagRole: TagRoleOption,
  details?: DetailOption,
): string {
  const parts = [
    ...[pageName, containerType, tagType, tagRole],
    ...(details ? [details.split(' ').join('_').toLowerCase()] : []),
  ]
  return parts.join('-')
}

export type PageNameOption =
  | 'home'
  | 'search'
  | 'event'
  | 'hospital'
  | 'doctor'
  | 'community'
  | 'column'
  | 'review'
  | 'selectDistrict'
  | 'login'
  | 'signup'
  | 'my'
  | 'wish'
  | 'download'
  | 'all' // 페이지나 도메인에 종속되지 않는 태그
export type ContainerTypeOption =
  | 'modal'
  | 'page'
  | 'section'
  | 'header'
  | 'footer'
  | 'bottomSheet'
  | 'popup'
  | 'paywall'
  | 'card'
  | 'tab'
export type TagTypeOption =
  | 'btn'
  | 'input'
  | 'link'
  | 'text'
  | 'textarea'
  | 'icon'
  | 'image'
  | 'list'
  | 'form'
  | 'radio'
  | 'checkbox'
  | 'qr'
  | 'component'
export type TagRoleOption =
  | 'submit'
  | 'cancel'
  | 'login'
  | 'signOut'
  | 'title'
  | 'description'
  | 'textInput'
  | 'text'
  | 'open'
  | 'close'
  | 'request'
  | 'confirm'
  | 'tag'
  | 'moveTo'
  | 'expand'
  | 'ui'
  | TagSubjectOptions
export type TagSubjectOptions =
  | 'district'
  | 'sex'
  | 'agree'
  | 'profile'
  | 'like'
  | 'dislike'
  | 'filter'
  | 'sort'
  | 'search'
  | 'reservation'
  | 'comment'
  | 'save'
  | 'card'
  | (string & NonNullable<unknown>)
export type DetailOption =
  | 'primary'
  | 'secondary'
  // Position
  | 'left'
  | 'right'
  // 로그인 유형
  | 'kakao'
  | 'google'
  | 'email'
  | 'naver'
  | 'apple'
  | 'line'
  // input
  | 'password'
  | (string & NonNullable<unknown>)
